export default "__VITE_ASSET__cf012e20__"